export function redirectToMenu(qrCode) {
  if (qrCode.length !== 3) {
    return false
  }

  window.location.href = `https://cardapio.pedimos.com.br/menu.php?code=${qrCode}`;
  return true
}
